import SERVER_URL from '../Global';
import { errorInterceptor } from '../util/axiosConfig';
const axios = require('axios').default;

export default class EditionService {
    constructor(token) {
        this.api_token = token;
        this.client = null;
        this.api_url = SERVER_URL;
    }
    init = () => {
        let headers = {
            Accept: "application/json",
        };
        if (this.api_token) {
            headers.Authorization = `Bearer ${this.api_token}`;
        }
        this.client = axios.create({ baseURL: this.api_url, timeout: 0, headers: headers });
        this.client.interceptors.response.use(errorInterceptor);

        return this.client;
    };

    getEditionList = (data) => {
        return this.init().post('api/edition/list', data);
    };

    getEdition = (id) => {
        return this.init().get('api/edition/' + id)
    }

    deleteEdition = (id) => {
        return this.init().delete('api/edition/' + id);
    }

    addEdition = (data) => {
        return this.init().post('api/edition', data);
    };

    updateEdition = (data) => {
        return this.init().put('api/edition', data);
    }
}


// WEBPACK FOOTER //
// ./src/Services/editionService.js